module.exports = "<canvas id=draw-line></canvas>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/draw-line/draw-line.html
 ** module id = 148
 ** module chunks = 0
 **/